import { BooleanValidation, ObjectValidation } from '../../../../../utils/component-validations';
import { fn, hash } from '@ember/helper';
import ListItem from './item.gjs';
import Menu from '../../../core/menu/base.gjs';
import Super from '../../../core/menu/parent.gjs';

export default class SpdsInputDropdownListMenu extends Super {
  arguments = [
    new BooleanValidation({ required: ['open'] }),
    new ObjectValidation({ required: ['anchorElement'] }),
  ];
  baseClass = 'spds-input-dropdown-list-menu';

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @animated={{true}}
      @id={{this.id}}
      @open={{@open}}
      class={{this.classes}}
      data-test-spds-input-dropdown-list-menu
      {{this.validateArguments}}
      ...attributes
    >
      {{yield
        (hash
          item=(component
            ListItem
            onClick=@onSelect
            registerComponent=(fn this.registerItem false)
            retainSelection=@retainSelection
            unregisterComponent=this.unregisterItem
          )
        )
      }}
    </Menu>
  </template>
}
